var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"elevation":"2","fab":"","bottom":"","right":"","fixed":"","x-large":"","color":"#008d36","href":"tel:9981040356"}},[_c('v-icon',{attrs:{"color":"#ffffff","x-large":""}},[_vm._v("mdi-phone")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }